import type { FC } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `Reverse ETL`,
  heading: `Activate warehouse data in all of your destination tools`,
  description: `Automatically sync warehouse data with essential customer engagement tools to enhance personalization, boost loyalty, and improve experiences.`,
}

const FORM_ID = `retl-demo-request`

const Hero: FC = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <StyledHeroRecipeCopy>
          <StyledCopyTextOverline tag="h5" variant="overline">
            {copy.overline}
          </StyledCopyTextOverline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <StyledHeroRecipeForm>
            <DemoForm
              isProgressive={true}
              customFormIdentifier={FORM_ID}
              customTrackingType={FORM_ID}
              successMessageAppearance="twilioLight"
            />
          </StyledHeroRecipeForm>
        </StyledHeroRecipeCopy>

        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image
              width="639"
              height="472"
              src={heroPng2x}
              alt={`Illustration: ${copy.heading}`}
              loading="lazy"
            />
          </Picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const StyledCopyTextOverline = styled(CopyText.Overline)`
  text-transform: initial;
  letter-spacing: 0;
`

const StyledHeroRecipeForm = styled(HeroRecipe.Form)`
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    margin-left: initial;
    margin-right: initial;
  }
`

const StyledHeroRecipeCopy = styled(HeroRecipe.Copy)`
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    text-align: left;
  }
`

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
